import { render, staticRenderFns } from "./TemperatureEdit.vue?vue&type=template&id=4f64cf3a&scoped=true&"
import script from "./TemperatureEdit.vue?vue&type=script&lang=js&"
export * from "./TemperatureEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f64cf3a",
  null
  
)

export default component.exports